import classNames from 'classnames';
import React from 'react';

import StudentHomepageSidebarContent from './StudentHomepageSidebarContent';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

interface Props extends PropsWithClassNameOptional {
  pathname: string;
}

export default function StudentHomepageSidebarDesktop({className, pathname}: Props) {
  const {isSidebarExpanded} = useStudentDashboard();

  return (
    <div className={classNames(className, 'hidden m:block')}>
      <div
        className={classNames(
          'relative! z-10 flex h-full w-[310px] flex-col gap-x3 px-x4 pt-x7 pb-x3 transition-[left] duration-200',
          {'left-[0]': isSidebarExpanded},
          {'-left-[310px]': !isSidebarExpanded}
        )}
      >
        <StudentHomepageSidebarContent pathname={pathname} />
      </div>
    </div>
  );
}
